import Providers from 'providers';

import Pay from './Pay';
import { GlobalStyles } from './Pay.styled';

export function PayApp() {
  return (
    <Providers>
      <Pay />
      <GlobalStyles />
    </Providers>
  );
}
